import React from 'react';
import PageLayout from '../../components/base/PageLayout';

const WatchListPage = () => {
  return (
    <PageLayout>
      <p>Content...</p>
    </PageLayout>
  );
}

export default WatchListPage